<template>
  <Layout>
    <div class="w-full">
      <!-- Banner 轮播区 -->
      <div class="relative w-full aspect-[16/9] lg:aspect-[21/9] lg:max-h-[500px] overflow-hidden bg-gray-900">
        <div
          v-for="(image, index) in carouselImages"
          :key="index"
          class="absolute inset-0 transition-opacity duration-700"
          :class="currentIndex === index ? 'opacity-100' : 'opacity-0'"
        >
          <img :src="image.src" :alt="image.alt" class="w-full h-full object-cover">
        </div>

        <button class="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-black/40 text-white flex items-center justify-center hover:bg-black/60 transition-colors" @click="prevSlide">&#10094;</button>
        <button class="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-black/40 text-white flex items-center justify-center hover:bg-black/60 transition-colors" @click="nextSlide">&#10095;</button>

        <div class="absolute bottom-4 left-1/2 -translate-x-1/2 flex space-x-2">
          <span
            v-for="(image, index) in carouselImages"
            :key="index"
            class="w-2.5 h-2.5 rounded-full cursor-pointer transition-colors"
            :class="currentIndex === index ? 'bg-white' : 'bg-white/50'"
            @click="goToSlide(index)"
          ></span>
        </div>
      </div>

      <!-- 优势卡片区 -->
      <div class="section max-w-6xl mx-auto px-4 lg:px-8">
        <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div
            v-for="(advantage, index) in advantageList"
            :key="index"
            class="bg-white rounded-lg shadow-md p-6 text-center hover:shadow-lg transition-shadow"
          >
            <h2 class="text-xl font-bold text-gray-800 mb-3">{{ advantage.title }}</h2>
            <img :src="advantage.cover" :alt="advantage.title" class="w-full h-48 object-cover rounded mb-3">
            <p class="text-gray-600 text-sm">{{ advantage.desc }}</p>
          </div>
        </div>
      </div>

      <!-- 项目案例区 -->
      <div v-if="homeEquipmentList && homeEquipmentList.length" class="section max-w-6xl mx-auto px-4 lg:px-8 bg-gray-50">
        <div class="section--header">
          <h3 class="section--title">Our Supermarket Projects All Over The World</h3>
        </div>
        <div class="grid grid-cols-2 lg:grid-cols-3 gap-4">
          <div
            v-for="(item, index) in homeEquipmentList"
            :key="index"
            class="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow"
          >
            <img :src="item.cover" :alt="item.title" class="w-full h-40 object-cover">
            <div class="p-3">
              <p class="text-sm font-medium text-gray-800 truncate">{{ item.title }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/components/common/CommonLayout";
import { getImageUrl } from '@/utils/image';
export default {
	name: "IndexView",
	components: {Layout},
	data(){
		return{
      tabIndex: 0,
			currentIndex: 0,
			intervalId: null,
      advantageList: [],
      homeEquipmentList: [],
      featureImage: getImageUrl('home/home-guangjiaohui.jpg'),
			carouselImages: [
				{ src: getImageUrl('banner-1.jpg'), alt: 'Banner 1' },
				{ src: getImageUrl('banner-2.jpg'), alt: 'Banner 2' }
			]
		}
	},
	mounted() {
		this.getAdvantages()
		this.getProjectCases()
		this.startAutoPlay()
	},
	beforeUnmount() {
		this.stopAutoPlay()
	},
	methods:{
		nextSlide() {
			this.currentIndex = (this.currentIndex + 1) % this.carouselImages.length
		},
		prevSlide() {
			this.currentIndex = (this.currentIndex - 1 + this.carouselImages.length) % this.carouselImages.length
		},
		goToSlide(index) {
			this.currentIndex = index
		},
		startAutoPlay() {
			this.intervalId = setInterval(() => {
				this.nextSlide()
			}, 3000)
		},
		stopAutoPlay() {
			if (this.intervalId) {
				clearInterval(this.intervalId)
				this.intervalId = null
			}
		},
		changeTab(index){
			this.tabIndex = index
		},
		async getAdvantages() {
			const resp = await this.getRequest("/api/advantages")
			if (resp && resp.data) {
				this.advantageList = (resp.data.data || []).map(item => ({
					cover: item.imageUrl,
					title: item.title,
					desc: item.description
				}))
			}
		},
		async getProjectCases() {
			const resp = await this.getRequest("/api/project-cases")
			if (resp && resp.data) {
				this.homeEquipmentList = (resp.data.data || []).map(item => ({
					cover: item.imageUrl,
					title: item.title
				}))
			}
		},
	},
}
</script>

